import styled from "styled-components";
import { breakpoints } from "../../../../constants/breakpoints";

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
  padding: 0;
  padding-top: 60px;

  ${breakpoints.tabletL} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 40px;
  }

  ${breakpoints.phoneL} {
    row-gap: 20px;
  }
`;

export const ContainerMainTitle = styled.div`
  position: relative;
  padding: 0 0 20px;
  width: fit-content;
`;

export const RectImg = styled.div`
  position: absolute;
  background: #c6e7ec;
  border-radius: 10px;
  transform: rotate(50deg);
  z-index: -1;
  height: 100px;
  width: 100px;
  left: -20px;
  top: -8px;

  ${breakpoints.tabletM} {
    height: 80px;
    width: 80px;
    left: -20px;
    top: -8px;
  }

  ${breakpoints.phoneL} {
    transform: rotate(50deg) translateX(10px);
    height: 50px;
    width: 50px;
    left: -15px;
    top: -6px;
  }

  ${breakpoints.phoneM} {
    height: 35px;
    width: 35px;
    left: -15px;
    top: -12px;
  }
`;

export const ContainerText = styled.div`
  width: 100%;

  > span {
    font-weight: bold;
    font-size: 4rem;
  }
  > span:nth-child(1) {
    color: #b92164;
  }
  > span:nth-child(2) {
    color: #a27dea;
  }

  ${breakpoints.tabletL} {
    > span {
      font-size: 3.6rem;
    }
  }
  ${breakpoints.tabletM} {
    > span {
      font-size: 3rem;
    }
  }
  ${breakpoints.phoneL} {
    > span {
      font-size: 1.8rem;
    }
  }

  ${breakpoints.phoneM} {
    > span {
      font-size: 1.2rem;
    }
  }
`;

export const ContainerDescription = styled.div`
  width: 100%;
  padding: 20px 0 60px;

  > p {
    font-size: 20px;
    line-height: 1.2;
    letter-spacing: normal;
    font-size: 22px;

    > span {
      color: #ad00fe;
      font-weight: bold;
    }
  }

  ${breakpoints.tabletL} {
    text-align: justify;
    padding: 0 30px;
  }

  ${breakpoints.phoneL} {
    padding: 40px 10px 20px;
  }
`;

export const ContainerHeaderLeft = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export const ContainerHeaderRight = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContainerRight = styled.div`
  width: 350px;
  height: 350px;
  background: #bed9c5;
  border-radius: 50%;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  ${breakpoints.phoneL} {
    width: 280px;
    height: 280px;
  }
`;

export const ContainerImages = styled.div`
  display: flex;
  flex-direction: row;
  padding: 80px 0 40px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 40px;

  > div {
    width: 50%;
  }

  > div img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > div:nth-child(1) img {
    width: 100%;
    max-width: 450px;
  }

  > div:nth-child(2) img {
    width: 100%;
    max-width: 380px;
  }

  ${breakpoints.tabletL} {
    padding: 40px 0 20px;

    > div:nth-child(1) img {
      max-width: 350px;
    }

    > div:nth-child(2) img {
      max-width: 280px;
    }
  }

  ${breakpoints.tabletM} {
    padding: 20px 0 10px;

    > div:nth-child(1) img {
      max-width: 300px;
    }

    > div:nth-child(2) img {
      max-width: 220px;
    }
  }

  ${breakpoints.phoneL} {
    gap: 20px;
    padding: 20px 0 0;

    > div:nth-child(1) img {
      max-width: 200px;
    }

    > div:nth-child(2) img {
      max-width: 150px;
    }
  }

  ${breakpoints.phoneM} {
    gap: 20px;
    padding: 20px 0 0;

    > div:nth-child(1) img {
      max-width: 150px;
    }

    > div:nth-child(2) img {
      max-width: 80px;
    }
  }
`;

export const ContainerMoreInfo = styled.div`
  justify-content: space-between;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  display: flex;
  width: 100%;

  ${breakpoints.tabletL} {
    gap: 50px;
  }

  ${breakpoints.phoneL} {
    flex-direction: column;
  }
`;

export const ContainerTitleInfo = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;

  ${breakpoints.tabletL} {
    justify-content: flex-start;
    width: 100%;
  }
`;

export const ContainerButton = styled.div`
  width: 50%;
  display: flex;
  justify-content: right;

  > div {
    border: double 1px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
      linear-gradient(
        90deg,
        rgba(238, 102, 77, 1) 0%,
        rgba(212, 69, 233, 1) 100%
      );
    background-origin: border-box;
    background-clip: padding-box, border-box;
    width: 90%;
    padding: 2px;

    > a {
      text-decoration: none;
      width: 100%;
      background: linear-gradient(
        90deg,
        rgba(238, 102, 77, 1) 0%,
        rgba(212, 69, 233, 1) 100%
      );
      color: white;
      border: 0;
      outline: none;
      padding: 10px 15px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 5px;
      font-size: 1.6rem;
      font-weight: 400;
      cursor: pointer;

      > svg {
        max-width: 30px;
        width: 100%;
      }
    }
  }

  ${breakpoints.tabletL} {
    width: 100%;

    > div button {
      font-weight: bold;
      font-size: 1.2rem;
      outline: none;
    }
  }

  ${breakpoints.tabletM} {
    width: 100%;

    > div button {
      font-size: 0.9rem;
      outline: none;
    }
  }

  ${breakpoints.phoneL} {
    > div {
      width: 100%;
    }

    > div button {
      font-size: 1.2rem;
      width: 100%;
      outline: none;
    }
  }
`;

export const ContainerTextLogo = styled.div`
  position: relative;
  left: 40px;
  top: 8px;

  > h2 {
    width: fit-content;
    color: #b92164;
    font-weight: bold;
    line-height: 0.8;
    font-size: 3.8rem;

    > span {
      color: #a27dea;
    }
  }
  > h5 {
    margin-top: 15px;
    margin-left: 50px;
    font-size: 28px;
    font-size: 1.7rem;
  }

  ${breakpoints.tabletL} {
    > h2 {
      font-size: 3.2rem;
    }

    > h5 {
      font-size: 1.2rem;
    }
  }

  ${breakpoints.tabletM} {
    > h2 {
      font-size: 2.4rem;
    }

    > h5 {
      font-size: 1rem;
    }
  }

  ${breakpoints.phoneL} {
    h2 {
      font-size: 2.4rem;
    }

    > h5 {
      font-size: 1rem;
    }
  }
`;

export const ContainerImage = styled.div`
  position: absolute;
  width: 120px;
  height: 100%;
  left: 0;
  top: -10px;

  > img {
    height: 140px;
  }

  ${breakpoints.tabletM} {
    width: 100px;

    > img {
      height: 100px;
    }
  }

  ${breakpoints.phoneL} {
    width: 100px;

    > img {
      height: 100px;
    }
  }
`;

export const ContainerLogoText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
